import { ObservableShape } from './ObservableShape';
import Pamela              from '@revodigital/pamela';
import { Editor }          from './Editor';

export class ObservableTable extends ObservableShape<Pamela.Table> {
  constructor(shape: Pamela.Table, editor: Editor) {
    super(shape, editor);
  }
}
